import React from 'react';

import { PageLoader } from '@crehana/compass.ui/v2';
import { useFeatureFlag } from '@crehana/feature-flags/react';

import { DiplomasProps } from '@/shared/components';

import DiplomasPageNew from './diplomas-page-new';
import DiplomasSection from './DiplomasSection';

const CertificatesCollaboratorPage: React.FC<DiplomasProps> = ({
  ...props
}) => {
  const { flagValue: isEnabled, loading } = useFeatureFlag(
    'LEARNING_MIGRATE_USER_CERTIFICATE_QUERY',
  );

  if (loading) {
    return <PageLoader />;
  }

  if (!isEnabled) {
    return <DiplomasSection {...props} />;
  }

  return <DiplomasPageNew {...props} />;
};

export default CertificatesCollaboratorPage;
